import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'

const InteractorFundPaymentApproval = () => {
  const { t } = useTranslation()
  const fundPaymentApproval = useCallback(
    (payload, loading) => {
      confirmationAlert({
        message: `${
          payload.status === 'REJECT'
            ? t('message.confirm_reject_payment')
            : t('message.confirm_approve_payment')
        }`,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/fund-payment/approval', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_updated'),
                timer: 1500,
                reload: true,
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { fundPaymentApproval }
}

export default InteractorFundPaymentApproval
